import { useEventListener, unrefElement } from '@vueuse/core';
import type { Ref } from 'vue';
export function useTrueSelfClick(
  element: Ref<HTMLElement | undefined>,
  callback: (event: MouseEvent) => void,
) {
  let clickStarted = false;
  function check(event: MouseEvent) {
    return event.target === unrefElement(element);
  }
  useEventListener(element, 'mousedown', (event: MouseEvent) => {
    if (check(event)) {
      clickStarted = true;
    }
  });
  useEventListener(document, 'mouseup', (event: MouseEvent) => {
    if (clickStarted && check(event)) {
      callback(event);
    }
    clickStarted = false;
  });
}
